export enum RegistrationStatus {
  InProgress = 1,
  PendingByAdmin = 2,
  Rejected = 3,
  Finished = 4,
}
